import React, { useState, useEffect } from 'react';
import Tooltip from '../../ViewWrapperContainer/ViewWrapper/ToolTip/ToolTip';

// Use for buttons that need to swap between
// primaryColor and backgroundColor for hover state

const ButtonHoverPrimary = ({
  hovering,
  active,
  onEnter,
  onLeave,
  color,
  backgroundColor,
  handleClick,
  myRef,
  children,
  tooltip,
  isMobile,
  tooltipClass,
  position = 'relative',
  ...rest
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const styles =
    (!isMobile && hovering) || active
      ? { color: backgroundColor, backgroundColor: color }
      : { color, backgroundColor };

  const focusHandler = bool => {
    if (showTooltip !== bool) {
      setShowTooltip(bool);
    }
  };

  const escapeFunction = e => {
    if (e.key === 'Escape') {
      setShowTooltip(false);
    }
  };

  const clickHandler = e => {
    // hide tooltip when button is clicked
    setShowTooltip(false);
    if (typeof handleClick === 'function') {
      handleClick(e);
    }
  };

  useEffect(() => {
    tooltip && document.addEventListener('keydown', escapeFunction, false);
    return () =>
      tooltip && document.removeEventListener('keydown', escapeFunction, false);
  }, [tooltip]);

  const show = !isMobile && (hovering || (showTooltip && !hovering));
  return (
    <div style={tooltip ? { position, marginRight: '10px' } : {}}>
      <button
        style={styles}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        onClick={clickHandler}
        onFocus={() => focusHandler(true)}
        onBlur={() => focusHandler(false)}
        ref={myRef}
        data-testid="button-hover-primary"
        {...rest}
      >
        {children}
      </button>
      {tooltip && (
        <Tooltip
          style={{ color: backgroundColor, backgroundColor: color }} // default toolTip to hover colors as only shown with hover event
          show={show}
          tooltipClass={tooltipClass}
          {...tooltip}
        />
      )}
    </div>
  );
};

export default ButtonHoverPrimary;
